export class JobError extends Error {
  public code?: string;

  constructor(message: string = '', code?: string) {
    super(message);
    this.name = 'JobError';
    this.message = message;
    this.code = code;
  }
}

export const isJobError = (error: Error): boolean => error instanceof JobError;
